<p>base component for all columns</p>
